import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

import '@/utils/rem.js'

Vue.config.productionTip = false

import apis from '@/views/center/apis'
new Vue({
    data: {
        userInfo: {},
        async getUsreInfo() {
            let user_id = localStorage.getItem('user_id')
            if (!user_id) return
            let r = await apis.getUserInfo(user_id)
            this.userInfo = r.data
        },
    },
    router,
    store,
    render: function (h) { return h(App) }
}).$mount('#app')
